import { editMenuPrintConfigurationRequest } from './api';
import { MenuPrintConfiguration } from './models/menuPrintConfiguration';

export const menuPrintConfigurationEdit = async (menuPrintConfiguration) => {
  const response = await editMenuPrintConfigurationRequest(menuPrintConfiguration.guid, menuPrintConfiguration);
  return MenuPrintConfiguration.toInstance(response);
};
